import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlankGw = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6371_90880)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.31351 5.07617C6.48473 5.24717 6.78343 5.2474 6.95511 5.07617L7.11331 4.91699H9.15042V6.79883H7.89456C7.18401 6.79883 6.82389 6.95167 6.69046 7.31055L6.64749 7.44336C6.64592 7.45056 6.64245 7.46223 6.63773 7.47461L6.62991 7.49609C6.355 8.28641 5.61704 8.80259 4.793 8.80273C4.72955 8.80273 4.66549 8.80002 4.60159 8.79395C3.63422 8.70067 2.86524 7.86403 2.85062 6.88965C2.84261 6.36553 3.04074 5.87094 3.40921 5.49707C3.77731 5.12313 4.26898 4.91699 4.793 4.91699H6.15433L6.31351 5.07617ZM4.793 5.36719C4.39052 5.36722 4.01255 5.52498 3.72952 5.8125C3.44631 6.1 3.29382 6.47993 3.29984 6.88281C3.31109 7.63139 3.90281 8.27415 4.64554 8.3457C5.33768 8.41252 5.97979 8.00015 6.20609 7.34375L6.21487 7.31934L6.2178 7.3125L6.26663 7.16113C6.53733 6.4322 7.32533 6.34863 7.89456 6.34863H8.70023V5.36719H7.29984L7.27347 5.39453C7.10299 5.56524 6.87611 5.65911 6.6348 5.65918C6.39354 5.65918 6.16663 5.56485 5.99612 5.39453L5.96878 5.36719H4.793ZM4.793 5.76953C5.39465 5.76953 5.88382 6.2587 5.88382 6.86035C5.88367 7.46187 5.39455 7.95117 4.793 7.95117C4.1915 7.95111 3.70233 7.46183 3.70218 6.86035C3.70218 6.25874 4.1914 5.7696 4.793 5.76953ZM4.793 6.21875C4.43958 6.21882 4.15237 6.50692 4.15237 6.86035C4.15253 7.21366 4.4399 7.50091 4.793 7.50098C5.14638 7.50098 5.43445 7.2137 5.4346 6.86035C5.4346 6.50688 5.14647 6.21875 4.793 6.21875ZM8.37308 3.72754L7.49319 4.60645L7.17484 4.28906L8.05472 3.40918L8.37308 3.72754ZM6.09378 4.2832L5.77542 4.60156L4.8848 3.70996L5.20218 3.39258L6.09378 4.2832ZM6.85941 4.22168H6.40921V3.19922H6.85941V4.22168Z",
					fill: "#37003C"
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: -.49129,
					y1: -.551103,
					x2: 12.5087,
					y2: 11.4489,
					stroke: "#FF0000",
					strokeWidth: 1.5
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 0.75C8.89949 0.75 11.25 3.10051 11.25 6C11.25 8.89949 8.89949 11.25 6 11.25C3.10051 11.25 0.75 8.89949 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75Z",
			stroke: "#FF0000",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6371_90880",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z",
				fill: "white"
			})
		}) })
	]
});
export default SvgBlankGw;
